<div class="wrap wrapMain coverPathWidget">
  <form class="coverPathForm" id="beneForm" [formGroup]="beneForm">
    <div class="formRow subRow">
      <label class="headerLabel" for="childrenType">Children type</label>
      <div class="formElem contentPadding">
        <select-basic
          [propertyName]="'childrenType'"
          [placeholder]="'Select'"
          [optionValues]="childTypes"
          formControlName="childrenType"
          (valueChanged)="getSelectedChildOption()"
          [formGroupComponent]="true"
        ></select-basic>
      </div>
    </div>
    <div class="formRow" *ngIf="specificChildren">
      <label class="headerLabel" for="certainMarriage">Name of other parent</label>
      <fieldset class="name">
        <div class="split-row-col3">
          <div class="first contentPadding">
            <basic-text-input
              [propertyName]="'parentFirstName'"
              [placeholder]="'First name'"
              [parserType]="'Text'"
              [inputType]="'text'"
              type="text"
              formControlName="parentFirstName"
              [formGroupComponent]="true"
            ></basic-text-input>
          </div>
          <div class="middle contentPadding">
            <basic-text-input
              [propertyName]="'parentMiddleName'"
              [placeholder]="'Middle Name'"
              [parserType]="'Text'"
              [inputType]="'text'"
              type="text"
              formControlName="parentMiddleName"
              [formGroupComponent]="true"
            ></basic-text-input>
          </div>
          <div class="last contentPadding">
            <basic-text-input
              [propertyName]="'parentLastName'"
              [placeholder]="'Last name'"
              [parserType]="'Text'"
              [inputType]="'text'"
              type="text"
              formControlName="parentLastName"
              [formGroupComponent]="true"
            ></basic-text-input>
          </div>
        </div>
      </fieldset>
      <control-messages [control]="getChildControl(beneForm, 'parentFirstName')"></control-messages>
    </div>
    <div class="formRow">
      <fieldset class="perstirpes">
        <label for="perstirpes" class="headerLabel">Per stirpes?</label>
        <div class="info">
          In the case of the beneficiary's death, would you like to distribute benefits equally amongst their
          descendants?
        </div>
        <div class="contentPadding">
          <radio-group
            [propertyName]="'perStirpe'"
            [valueOptions]="perStirpeOptions"
            formControlName="perStirpe"
            [formGroupComponent]="true"
          ></radio-group>
        </div>
      </fieldset>
    </div>
    <div>
      <br />
    </div>
    <div class="childrenList" formArrayName="childrenList" id="childrenList">
      <div *ngFor="let child of childrenList.controls; let i=index" [formGroupName]="i" class="childForm">
        <hr />
        <div class="childCTA">
          <div class="headerWrapper">
            <input type="hidden" formControlName="id" />
            <label class="childHeader">Child {{i + 1}}</label>
          </div>
          <button class="btn" type="button" *ngIf="childrenList.length > 1" (click)="deleteChild(i);">
            Delete child
          </button>
        </div>
        <div class="formRow">
          <label class="headerLabel" for="name">Full Name</label>
          <fieldset class="name">
            <div class="contentPadding">
              <div class="split-row-col3">
                <div class="first">
                  <basic-text-input
                    [propertyName]="'firstName'"
                    [placeholder]="'First name'"
                    [parserType]="'Text'"
                    [inputType]="'text'"
                    type="text"
                    formControlName="firstName"
                    [formGroupComponent]="true"
                  ></basic-text-input>
                </div>
                <div class="middle">
                  <basic-text-input
                    [propertyName]="'middleName'"
                    [placeholder]="'Middle Name'"
                    [parserType]="'Text'"
                    [inputType]="'text'"
                    type="text"
                    formControlName="middleName"
                    [formGroupComponent]="true"
                  ></basic-text-input>
                </div>
                <div class="last">
                  <basic-text-input
                    [propertyName]="'lastName'"
                    [placeholder]="'Last name'"
                    [parserType]="'Text'"
                    [inputType]="'text'"
                    type="text"
                    formControlName="lastName"
                    [formGroupComponent]="true"
                  ></basic-text-input>
                </div>
              </div>
            </div>
          </fieldset>
        </div>

        <div class="formRow">
          <div class="formElem">
            <label for="dateOfBirth" class="headerLabel">Date of Birth</label>
            <div class="contentPadding">
              <basic-text-input
                [propertyName]="'dateOfBirth'"
                [placeholder]="'MM/DD/YYYY'"
                (onBlur)="validateDate(i)"
                [inputMask]="{mask: dobMask}"
                [parserType]="'Text'"
                [inputType]="'text'"
                type="text"
                formControlName="dateOfBirth"
                [formGroupComponent]="true"
              ></basic-text-input>
              <control-messages [control]="getChildControl(child, 'dateOfBirth')"></control-messages>
              <div class="error" *ngIf="invalidDate.has(i)">Invalid date</div>
            </div>
          </div>
        </div>

        <div class="formRow">
          <fieldset class="address">
            <div class="groupHeader">
              <label for="headerLabel" class="headerLabel">
                Address
                <span class="optional">(optional)</span>
              </label>
              <button class="btn-margin" type="button" (click)="resetAddress(i)">clear address</button>
            </div>
            <div class="split-row-col2 contentPadding">
              <div class="colLeft street contentPadding">
                <basic-text-input
                  [propertyName]="'street-'+i"
                  [placeholder]="'Address line 1'"
                  [parserType]="'Text'"
                  [inputType]="'text'"
                  type="text"
                  formControlName="street"
                  [formGroupComponent]="true"
                ></basic-text-input>
                <control-messages [control]="getChildControl(child, 'street')"></control-messages>
              </div>
              <div class="colRight line1 contentPadding">
                <basic-text-input
                  [propertyName]="'line1-'+i"
                  [placeholder]="'Address line 2'"
                  [parserType]="'Text'"
                  [inputType]="'text'"
                  type="text"
                  formControlName="line1"
                  [formGroupComponent]="true"
                ></basic-text-input>
              </div>
            </div>
            <div class="split-row-col2 city contentPadding">
              <div class="colLeft line2 contentPadding">
                <basic-text-input
                  [propertyName]="'line2-'+i"
                  [placeholder]="'Address line 3'"
                  [parserType]="'Text'"
                  [inputType]="'text'"
                  type="text"
                  formControlName="line2"
                  [formGroupComponent]="true"
                ></basic-text-input>
              </div>
              <div class="colRight city contentPadding">
                <basic-text-input
                  [propertyName]="'city-'+i"
                  [placeholder]="'City'"
                  [parserType]="'Text'"
                  [inputType]="'text'"
                  type="text"
                  formControlName="city"
                  [formGroupComponent]="true"
                ></basic-text-input>
                <control-messages [control]="getChildControl(child, 'city')"></control-messages>
              </div>
            </div>
            <div class="split-row-col2 contentPadding">
              <div class="colLeft state contentPadding">
                <select-basic
                  [propertyName]="'state-'+i"
                  [placeholder]="'State'"
                  [optionValues]="stateList"
                  formControlName="state"
                  [label]="'State'"
                  [formGroupComponent]="true"
                ></select-basic>
              </div>
              <div class="colRight zip contentPadding">
                <basic-text-input
                  [propertyName]="'zip-'+i"
                  [placeholder]="'ZIP'"
                  (valueChanged)="zipCodeLookup(i)"
                  [parserType]="'Text'"
                  [inputType]="'text'"
                  type="text"
                  formControlName="zip"
                  [formGroupComponent]="true"
                ></basic-text-input>
                <control-messages [control]="getChildControl(child, 'zip')"></control-messages>
              </div>
            </div>
          </fieldset>
        </div>

        <div class="formRow">
          <div class="split-row-col2">
            <div class="colLeft">
              <label for="phone" class="headerLabel">
                Phone Number
                <span class="optional">(optional)</span>
              </label>
              <div class="contentPadding">
                <basic-text-input
                  [propertyName]="'phone-'+i"
                  [placeholder]="'10 digit phone'"
                  (valueChanged)="formatPhone(i)"
                  [inputMask]="{mask: phoneMask}"
                  [parserType]="'Text'"
                  [inputType]="'text'"
                  type="text"
                  formControlName="phone"
                  [formGroupComponent]="true"
                ></basic-text-input>
                <div class="error" *ngIf="invalidPhone.has(i)">Not a valid phone number</div>
              </div>
            </div>
            <div class="colRight">
              <label class="headerLabel" for="ssn">
                Social Security Number
                <span class="optional">(optional)</span>
              </label>
              <div class="contentPadding">
                <basic-text-input
                  [propertyName]="'ssn-'+i"
                  [placeholder]="'9 digit SSN'"
                  (valueChanged)="formatSSN(i,$event)"
                  [inputMask]="{mask: ssnMask}"
                  [parserType]="'Text'"
                  [inputType]="'text'"
                  type="text"
                  formControlName="ssn"
                  [formGroupComponent]="true"
                ></basic-text-input>
                <div class="error" *ngIf="invalidSSN.has(i)">Not a valid SSN</div>
              </div>
            </div>
          </div>
          <div *ngIf="unevenChildRatios">
            <td>
              <div class="percent">
                <basic-text-input
                  [propertyName]="'ratio'"
                  [parserType]="'Text'"
                  [inputType]="'text'"
                  type="text"
                  [placeholder]="'Ratio'"
                  formControlName="ratio"
                  [disableConditionally]="true"
                  [formGroupComponent]="true"
                ></basic-text-input>
              </div>
            </td>
          </div>
        </div>
        <div class="formRow">
          <div class="split-row-col2">
            <div class="colLeft">
              <label for="email" class="headerLabel">
                Email
                <span class="optional">(optional)</span>
              </label>
              <div class="contentPadding">
                <basic-text-input
                  [propertyName]="'email-'+i"
                  [placeholder]="'Email Address'"
                  [parserType]="'Text'"
                  [inputType]="'text'"
                  type="text"
                  formControlName="email"
                  [formGroupComponent]="true"
                ></basic-text-input>
                <div class="error" *ngIf="invalidEmail.has(i)">Not a valid email</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="cta addChildRow">
    <button type="button" class="btnAddChild" (click)="addChild();">Add child</button>
  </div>
  <hr />
</div>

<div class="wrap wrapFoot">
  <div class="cta">
    <button type="submit" class="btnSubmit" [disabled]="isDisabled()" (click)=" checkSave()">Submit</button>
    <button type="button" class="btnCancel" (click)="cancel();">Cancel</button>
  </div>
</div>

<modalChildRatio *ngIf="modalService.showChildModal" (click)="continueSave()"></modalChildRatio>
